module.exports = __webpack_public_path__ + "img/BOOK-TITLE-01-MOBILE.17365f57.png";